import { ParametrosPaginacao } from './../../../model/interface/parametros-paginacao';
import { TipoUsuarioEnum } from '../../../model/enum/tipo-usuario.enum';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TipoColunaEnum } from 'src/app/shared/tabela-crud/model/tipo-coluna.enum';;
import { ColumnModel, IColumModel } from 'src/app/shared/tabela-crud/model/IColum.model';
import { TokenService } from 'src/app/services/token.service';
import { AcoesExtraEnum } from 'src/app/shared/tabela-crud/tabela-acoes.enum';
import { EventoAcaoExtra, EventoAcaoCrud } from 'src/app/shared/tabela-crud/model/tabela-eventos.model';
import { DashboardAssessorCoreService } from '../../../core/dashboard-assessor-core.service';
import { DashboardEscritorioCoreService } from '../../../core/dashboard-escritorio-core.service';
import { paginacao } from 'src/app/constantes/parametros-paginacao';
import { PageEvent } from '@angular/material/paginator';
import { Paginacao } from 'src/app/shared/tabela-crud/tabela-paginacao';
import { ListaPaginada } from '../../../model/lista-paginada';
import { Investidor } from '../../../model/investidor';
import { InvestidorAssessorado } from '../../../model/investidor-assessorado';

@Component({
  selector: 'app-investidores',
  templateUrl: './investidores.component.html',
  styleUrls: ['./investidores.component.css']
})
export class InvestidoresComponent implements OnInit {

  colunasTabela: IColumModel[];
  listaInvestidor: any;
  quantidadeInvestidores = 0;
  investidoresAtivos = 0;

  uuidUsuario!: string;
  tipoUsuario!: string;
  tipoUsuarioEnum = TipoUsuarioEnum;
  configPagina: PageEvent = Paginacao.paginaConfig();

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private dashboardAssessorFacade: DashboardAssessorCoreService,
    private dashboardEscritorioFacade: DashboardEscritorioCoreService
  ) { }

  ngOnInit(): void {
    this.uuidUsuario = this.tokenService.carregarUsuarioLogado()?.uuidTipoUsuario;
    this.tipoUsuario = this.tokenService.carregarUsuarioLogado()?.tipoUsuario;

    if (this.uuidUsuario && this.tipoUsuario == TipoUsuarioEnum.ASSESSOR) {
      this.colunasTabela = [
        new ColumnModel('nome', 'Investidor'),
        new ColumnModel('status', 'Status', TipoColunaEnum.Tag),
        new ColumnModel('valorInvestido', 'Valor Investido', TipoColunaEnum.Valor),
        new ColumnModel('telefone', 'Telefone', TipoColunaEnum.Telefone),
      ];

      this.listarInvestidores(paginacao);

      this.dashboardAssessorFacade.getQuantidadeInvestidores(this.uuidUsuario).subscribe(
        res => this.quantidadeInvestidores = res.dados[0].quantidadeInvestidores
      );

      this.dashboardAssessorFacade.getQuantidadeInvestidoresAtivos(this.uuidUsuario).subscribe(
        res => this.investidoresAtivos = res.dados[0].quantidadeInvestidoresAtivos
      );
    } else if (this.uuidUsuario && this.tipoUsuario == TipoUsuarioEnum.ESCRITORIO) {
      this.colunasTabela = [
        new ColumnModel('nome', 'Investidor'),
        new ColumnModel('assessorNome', 'Assessor'),
        new ColumnModel('statusCadastro', 'Status', TipoColunaEnum.Tag),
        new ColumnModel('valorInvestido', 'Valor Investido', TipoColunaEnum.Valor),
        new ColumnModel('telefone', 'Telefone', TipoColunaEnum.Telefone),
      ];

      this.listarInvestidores(paginacao);

      this.dashboardEscritorioFacade.getQuantidadeInvestidores(this.uuidUsuario).subscribe(
        res => this.quantidadeInvestidores = res.dados[0].quantidadeInvestidores
      );

      this.dashboardEscritorioFacade.getQuantidadeInvestidoresAtivos(this.uuidUsuario).subscribe(
        res => this.investidoresAtivos = res.dados[0].quantidadeInvestidoresAtivos
      );
    }
  }

  listarInvestidores(paginacao: ParametrosPaginacao) {
    if (this.uuidUsuario && this.tipoUsuario == TipoUsuarioEnum.ASSESSOR) {
      this.dashboardAssessorFacade.getInvestidoresPorAssessor(this.uuidUsuario, paginacao).subscribe(
        res => this.setListaInvestidores(res.dados[0])
      );
    } else if (this.uuidUsuario && this.tipoUsuario == TipoUsuarioEnum.ESCRITORIO) {
      this.dashboardEscritorioFacade.getInvestidoresPorEscritorio(this.uuidUsuario, paginacao).subscribe(
        res => this.setListaInvestidores(res.dados[0])
      );

    }
  }

  setListaInvestidores(investidores: ListaPaginada<InvestidorAssessorado> | ListaPaginada<Investidor>) {
    this.listaInvestidor = investidores.content;
    this.configPagina.length = investidores.totalElements;
    this.configPagina.pageSize = investidores.pageable?.pageSize;
    this.configPagina.pageIndex = investidores.pageable?.pageNumber;
  }

  redirecionarDashboardInvestidor(uuidInvestidor: string) {
    this.tokenService.armazenarUuid(uuidInvestidor);
    this.router.navigate([`dashboard/investidor`]);
  }

  redirecionarDetalhesInvestidor(evento: EventoAcaoCrud<any>): void {
    let investidorUUID = evento.objeto.uuid;
    this.router.navigate([`investidor/${investidorUUID}/detalhes`]);
  }

  executarAcaoExtra(evento: EventoAcaoExtra<any>): void {
    if (evento.acaoExtra == AcoesExtraEnum.Dashboard) {
      this.redirecionarDashboardInvestidor(evento.objeto);
      this.tokenService.armazenarUuid(evento.objeto.uuid);
    }
  }

  mudarPagina(pageEvent: PageEvent) {
    let paginacao: ParametrosPaginacao = {
      tamanhoPagina: pageEvent.pageSize,
      indicePagina: pageEvent.pageIndex
    }
    this.listarInvestidores(paginacao);
  }


}
